import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { InputComponent } from "@shared/controls/input/input.component";
import { CustomFormValidators } from "@shared/validators/custom-form-validators";
import { directorFullNameValidatorMsg } from "@shared/validators/custom-form-validators-messages";
import { AddressFormGroup, AddressFormGroupComponent } from "../address-form-group/address-form-group.component";
import { ReusableFormGroupComponent } from "../reusable-form-group/reusable-form-group.component";

export interface RelationshipFormGroupControls {
  name: FormControl<string | null>;
  address: AddressFormGroup;
}

export type IndividualRelationshipFormGroup = FormGroup<RelationshipFormGroupControls>

@Component({
  selector: 'app-relationship-form-group',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputComponent,
    AddressFormGroupComponent
  ],
  templateUrl: 'individual-relationship-form-group.component.html',
})
export class IndividualRelationshipFormGroupComponent extends ReusableFormGroupComponent<IndividualRelationshipFormGroup> {
  @Input() nameControlLabel = '';
  @Input() addressControlLabel = '';
  @Input() hideAddress = false;

  protected readonly directorFullNameValidatorMsg = directorFullNameValidatorMsg;

  static override defineForm(): IndividualRelationshipFormGroup {
    return new FormGroup<RelationshipFormGroupControls>({
      name: new FormControl(null, [Validators.required, CustomFormValidators.fullNameValidator]),
      address: AddressFormGroupComponent.defineForm()
    });
  }
}
